import { DialogService, GridAction } from '@eforall/dashboard';
import { PersonDialog } from 'ui/widget';
import { AcceleratorAreaService } from '../../../../../accelerator-area.service';
import { AttendeeRow } from '../attendance.dialog';

export function getActions(dialogService: DialogService, accAreaAService: AcceleratorAreaService, accSessionId?: number) {

	const actions: GridAction<AttendeeRow>[] = [
		{
			iconClass: 'fa-regular fa-user',
			label: 'Explore Person',
			isEnabled: rows => rows.length == 1,
			execute: async rows => {
				await dialogService.showCustom(PersonDialog, { data: { personId: rows[0]!.personId, toEdit: false } }, 800, 800);
			}
		},
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'Mark as Present',
			isEnabled: rows => !!rows.length && accAreaAService.canEdit() && !!rows.find(r => !r.attended || r.attended == 'Absent'),
			execute: async rows => {
				if (!accAreaAService.canEdit() || !accSessionId) return;
				await accAreaAService.setSessionAttendeeStatus(accSessionId, rows.map(r => ({ accVentureId: r.accVentureId, personId: r.personId })), 'Present');

			}
		},
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'Mark as Absent',
			isEnabled: rows => !!rows.length && accAreaAService.canEdit() && !rows.find(r => r.survey) && (!!rows.find(r => !r.attended || r.attended == 'Present')),
			execute: async rows => {
				if (!accAreaAService.canEdit() || !accSessionId) return;
				const attendeeSurveyExists = rows.filter(r => r.survey).map(r => r.fullName).join(', ');
				if (attendeeSurveyExists) {
					await dialogService.showMessage(`Entrepreneurs: ${attendeeSurveyExists} have already filled out the surveys so attendance cannot be changed to Absent`, 'Okay');
				}
				else {
					await accAreaAService.setSessionAttendeeStatus(accSessionId, rows.map(r => ({ accVentureId: r.accVentureId, personId: r.personId })), 'Absent');
				}
			}
		},
	];

	return actions;
}